// extracted by mini-css-extract-plugin
module.exports = {"default-arrows-container":"b1ddd01198--default-arrows-container--Vy8RU","default-arrows-wrapper":"b1ddd01198--default-arrows-wrapper--T4sQF"};